import { render, staticRenderFns } from "./u-pagination-elevated-tile.vue?vue&type=template&id=c9aabfa8&scoped=true&"
import script from "./u-pagination-elevated-tile.vue?vue&type=script&lang=js&"
export * from "./u-pagination-elevated-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9aabfa8",
  null
  
)

export default component.exports